<template>
  <div class="tabnavigationbar">
    <el-container>
      <el-header style="border-bottom: 1px solid #E4E4E4;">
        <el-breadcrumb separator-class="el-icon-arrow-right"
          style="height: 100%;line-height: 53px;color: #393939;font-size: 15px;">
          <el-breadcrumb-item>所在位置</el-breadcrumb-item>
          <el-breadcrumb-item>首页</el-breadcrumb-item>
          <el-breadcrumb-item>{{ titlename }}</el-breadcrumb-item>
        </el-breadcrumb>
      </el-header>
      <!-- <p style="height: 100px;margin: 0 auto;margin-top: 20px;" v-show="router == '7'">
        <img src="../assets/image/default-court.png" alt="" srcset="">
      </p> -->
      <el-tooltip v-show="router == '7'" class="item" effect="dark" content="点击前往法院官网页面" placement="top-start">
        <div class="court-pic" data-tooltip="这是一个滑动提示！" @click="seeNow">
          <h3>枣强县人民法院</h3>
          <img src="../assets/image/default-court.png" alt="" srcset="">
        </div>
      </el-tooltip>

      <el-container class="elaside1">
        <!-- 导航栏 -->
        <el-aside v-show="router != '7'" width="200px" style="border-right: 1px solid #E4E4E4;height: 782px;">
          <el-col :span="24">
            <el-menu :default-active="defaultactive" class="el-menu-vertical-demo">
              <el-menu-item index="1" @click="articlelist('/PjanNavigationbar', '1')">
                <img class="images" :style="filter.value == '1' ? filter.options : ''"
                  src="../assets/image/panjueanli.png" alt="">
                <span slot="title" :style="filter.value == '1' ? 'font-size:18px;font-weight:600;' : ''">判决案例</span>
              </el-menu-item>
              <el-menu-item index="2" @click="articlelist('/TjznNavigationbar', '2')">
                <img class="images" :style="filter.value == '2' ? filter.options : ''"
                  src="../assets/image/tiaojiezhinan.png" alt="">
                <span slot="title" :style="filter.value == '2' ? 'font-size:18px;font-weight:600;' : ''">调解指南</span>
              </el-menu-item>
              <el-menu-item index="3" @click="articlelist('/TjymdNavigationbar', '3')">
                <img class="images" :style="filter.value == '3' ? filter.options : ''"
                  src="../assets/image/tiaojieyuanmingdan.png" alt="">
                <span slot="title" :style="filter.value == '3' ? 'font-size:18px;font-weight:600;' : ''">调解员名单</span>
              </el-menu-item>
              <el-menu-item index="4" @click="articlelist('/XwdtNavigationbar', '4')">
                <img class="images" :style="filter.value == '4' ? filter.options : ''"
                  src="../assets/image/xinwendongtai.png" alt="">
                <span slot="title" :style="filter.value == '4' ? 'font-size:18px;font-weight:600;' : ''">新闻动态</span>
              </el-menu-item>
              <el-menu-item index="5" @click="articlelist('/SfwznNavigationbar', '5')">
                <img class="images" :style="filter.value == '5' ? filter.options : ''"
                  src="../assets/image/susongfuwuzhinan.png" alt="">
                <span slot="title" :style="filter.value == '5' ? 'font-size:18px;font-weight:600;' : ''">诉讼服务指南</span>
              </el-menu-item>
              <el-menu-item index="6" @click="articlelist('/JfznNavigationbar', '6')">
                <img class="images" :style="filter.value == '6' ? filter.options : ''"
                  src="../assets/image/jiefenzhinan.png" alt="">
                <span slot="title" :style="filter.value == '6' ? 'font-size:18px;font-weight:600;' : ''">解纷指南</span>
              </el-menu-item>
            </el-menu>
          </el-col>
        </el-aside>
        <!-- 文章列表 -->
        <el-main v-show="router != '7'">
          <JfznNavigationbar v-if="defaultactive == '6'" />
          <PjanNavigationbar v-if="defaultactive == '1'" />
          <SfwznNavigationbar v-if="defaultactive == '5'" />
          <TjymdNavigationbar v-if="defaultactive == '3'" />
          <TjznNavigationbar v-if="defaultactive == '2'" />
          <XwdtNavigationbar v-if="defaultactive == '4'" />
        </el-main>
      </el-container>
      <div class="elaside2 elas" v-show="router != '7'" style="width:95%;border-right: 1px solid #E4E4E4;height: 120px;">
        <el-col :span="24">
          <el-menu :default-active="defaultactive" class="el-menu-vertical-demo">
            <div class="elmenu">
              <el-menu-item index="1" @click="articlelist('/PjanNavigationbar', '1')">
                <!-- <img class="images" :style="filter.value == '1' ? filter.options : ''" src="../assets/image/panjueanli.png" alt=""> -->
                <span slot="title" :style="filter.value == '1' ? 'font-size:18px;font-weight:600;' : ''">判决案例</span>
              </el-menu-item>
              <el-menu-item index="2" @click="articlelist('/TjznNavigationbar', '2')">
                <!-- <img class="images" :style="filter.value == '2' ? filter.options : ''" src="../assets/image/tiaojiezhinan.png" alt=""> -->
                <span slot="title" :style="filter.value == '2' ? 'font-size:18px;font-weight:600;' : ''">调解指南</span>
              </el-menu-item>
              <el-menu-item index="3" @click="articlelist('/TjymdNavigationbar', '3')">
                <!-- <img class="images" :style="filter.value == '3' ? filter.options : ''" src="../assets/image/tiaojieyuanmingdan.png" alt=""> -->
                <span slot="title" :style="filter.value == '3' ? 'font-size:18px;font-weight:600;' : ''">调解员名单</span>
              </el-menu-item>
            </div>
            <div class="elmenu">
              <el-menu-item index="4" @click="articlelist('/XwdtNavigationbar', '4')">
                <!-- <img class="images" :style="filter.value == '4' ? filter.options : ''" src="../assets/image/xinwendongtai.png" alt=""> -->
                <span slot="title" :style="filter.value == '4' ? 'font-size:18px;font-weight:600;' : ''">新闻动态</span>
              </el-menu-item>
              <el-menu-item index="5" @click="articlelist('/SfwznNavigationbar', '5')">
                <!-- <img class="images" :style="filter.value == '5' ? filter.options : ''" src="../assets/image/susongfuwuzhinan.png" alt=""> -->
                <span slot="title" :style="filter.value == '5' ? 'font-size:18px;font-weight:600;' : ''">诉讼服务指南</span>
              </el-menu-item>
              <el-menu-item index="6" @click="articlelist('/JfznNavigationbar', '6')">
                <!-- <img class="images" :style="filter.value == '6' ? filter.options : ''" src="../assets/image/jiefenzhinan.png" alt=""> -->
                <span slot="title" :style="filter.value == '6' ? 'font-size:18px;font-weight:600;' : ''">解纷指南</span>
              </el-menu-item>
            </div>
          </el-menu>
        </el-col>
      </div>
      <div class="elaside2" style="width: 90%;margin: 10px auto;">
        <JfznNavigationbar v-if="defaultactive == '6'" />
        <PjanNavigationbar v-if="defaultactive == '1'" />
        <SfwznNavigationbar v-if="defaultactive == '5'" />
        <TjymdNavigationbar v-if="defaultactive == '3'" />
        <TjznNavigationbar v-if="defaultactive == '2'" />
        <XwdtNavigationbar v-if="defaultactive == '4'" />
      </div>
    </el-container>
  </div>
</template>
<script>
import JfznNavigationbar from '@/components/navigationbar/JfznNavigationbar';
import PjanNavigationbar from '@/components/navigationbar/PjanNavigationbar';
import SfwznNavigationbar from '@/components/navigationbar/SfwznNavigationbar';
import TjymdNavigationbar from '@/components/navigationbar/TjymdNavigationbar';
import TjznNavigationbar from '@/components/navigationbar/TjznNavigationbar';
import XwdtNavigationbar from '@/components/navigationbar/XwdtNavigationbar';
export default {
  props: ['router'],
  components: {
    JfznNavigationbar,
    PjanNavigationbar,
    SfwznNavigationbar,
    TjymdNavigationbar,
    TjznNavigationbar,
    XwdtNavigationbar
  },
  data() {
    return {
      defaultactive: '',
      filter: {
        value: '',
        options: 'filter: grayscale(0);transform: scale(1.1);font-size:18px;'
      },
      titlename: '判决案例'
    };
  },
  mounted() {
    // if(JSON.parse(sessionStorage.getItem("defaultactive"))){
    //   this.defaultactive = JSON.parse(sessionStorage.getItem("defaultactive"))
    //   this.filter.value = this.defaultactive;
    // }else{
    //   this.defaultactive = this.router
    //   this.filter.value = this.defaultactive;
    // }
    // setTimeout(() => {
    //   // if(this.defaultactive == '1') this.articlelist('/PjanNavigationbar','1')
    //   // if(this.defaultactive == '2') this.articlelist('/TjznNavigationbar','2')
    //   // if(this.defaultactive == '3') this.articlelist('/TjymdNavigationbar','3')
    // }, 100);
  },
  methods: {
    seeNow() {
      const url = 'https://tiaojie.court.gov.cn/court/283';//打开一个新的页面
      window.open(url, '_blank');
    },
    panduan(data) {
      if (data == '1') this.titlename = '判决案例'
      else if (data == '2') this.titlename = '调解指南'
      else if (data == '3') this.titlename = '调解员名单'
      else if (data == '4') this.titlename = '新闻动态'
      else if (data == '5') this.titlename = '诉讼服务指南'
      else if (data == '6') this.titlename = '解纷指南'
      else if (data == '7') this.titlename = '法院导航'
    },
    articlelist(data, arr) {
      sessionStorage.setItem("ssfwzn", JSON.stringify(''));
      sessionStorage.setItem("defaultactive", JSON.stringify(arr));
      if (data == this.$route.path) return
      setTimeout(() => {
        this.defaultactive = arr
        this.filter.value = arr
        this.$router.push(data)
      }, 100)
      this.$emit('articlelist', arr)
      this.panduan(arr)
    },
    handleOpen(key, keyPath) {
    },
    handleClose(key, keyPath) {
    }
  },
  watch: {
    router(val, oldval) {
      if (JSON.parse(sessionStorage.getItem("defaultactive"))) {
        this.defaultactive = JSON.parse(sessionStorage.getItem("defaultactive"))
        this.filter.value = this.defaultactive;
      } else {
        this.defaultactive = this.router
        this.filter.value = this.defaultactive;
      }
      if (this.defaultactive == '1') this.articlelist('/PjanNavigationbar', '1')
      if (this.defaultactive == '2') this.articlelist('/TjznNavigationbar', '2')
      if (this.defaultactive == '3') this.articlelist('/TjymdNavigationbar', '3')
      if (this.defaultactive == '5') {
        sessionStorage.setItem("defaultactive", JSON.stringify('5'));
        if ('/SfwznNavigationbar' == this.$route.path) return
        setTimeout(() => {
          this.defaultactive = '5'
          this.filter.value = '5'
          this.$router.push('/SfwznNavigationbar')
        }, 100)
        this.$emit('articlelist', '5')
        this.panduan('5')
      }
      if (this.defaultactive == '6') {
        sessionStorage.setItem("defaultactive", JSON.stringify('6'));
        if ('/JfznNavigationbar' == this.$route.path) return
        setTimeout(() => {
          this.defaultactive = '6'
          this.filter.value = '6'
          this.$router.push('/JfznNavigationbar')
        }, 100)
        this.$emit('articlelist', '6')
        this.panduan('6')
      }
      this.panduan(this.defaultactive)
    },
    immediate: true,
  }
};
</script>
<style lang="less" scoped>
.tabnavigationbar {
  width: 1196px;
  margin: 0 auto;
  background: #fff;
  box-shadow: 0px 0px 10px 0px rgba(31, 31, 31, 0.05);
  border-radius: 5px;
  margin-top: 50px;

  .tab_content {
    line-height: 50px;

    .tab_sent {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;

      p,
      span {
        font-size: 14px;
      }

      span {
        color: #999999;
      }
    }
  }

  .images {
    width: 20px;
    margin: 0 20px;
    filter: grayscale(100%);
  }

  .el-menu-vertical-demo {
    span {
      font-size: 16px;
    }
  }

}

.el-menu-item:hover img {
  filter: grayscale(0%);
  transform: scale(1.1);
}

.el-menu-item:hover span {
  font-size: 18px;
  font-weight: 600;
  color: #be1a0f;
}

.elaside2 {
  display: none;
}

@media screen and (max-width: 1200px) {
  .elaside1 {
    display: none;
  }

  .elaside2 {
    display: block;
    border: 0px !important;
  }

  .tabnavigationbar {
    width: 100%;
    margin: 0 auto;
    background: #fff;
    box-shadow: 0px 0px 10px 0px rgba(31, 31, 31, 0.05);
    border-radius: 5px;
    margin-top: 50px;

    .tab_content {
      line-height: 50px;

      .tab_sent {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;

        p,
        span {
          font-size: 14px;
        }

        span {
          color: #999999;
        }
      }
    }

    .images {
      width: 20px;
      margin: 0 20px;
      filter: grayscale(100%);
    }

    .el-menu-vertical-demo {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;

      .elmenu {
        display: flex;
        justify-content: center;
        align-items: center;
      }

      span {
        font-size: 16px;
      }
    }
  }

  .el-menu-item:hover img {
    filter: grayscale(0%);
    transform: scale(1.1);
  }

  .el-menu-item:hover span {
    font-size: 18px;
    font-weight: 600;
    color: #be1a0f;
  }
}

.court-pic {

  cursor: pointer;

  float: left;
  width: 100%;
  height: 500px;
  position: relative;

  h3 {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 5;
    line-height: 50px;
    color: #fff;
    padding-left: 20px;
    font-size: 18px;
    font-weight: 400;
  }

  img {
    width: 100%;
    height: 100%;
    display: block;
  }
}
</style>
